import { render, staticRenderFns } from "./HotmartAppHero.vue?vue&type=template&id=0b16e3d3&scoped=true"
import script from "./HotmartAppHero.js?vue&type=script&lang=js&external"
export * from "./HotmartAppHero.js?vue&type=script&lang=js&external"
import style0 from "./HotmartAppHero.scss?vue&type=style&index=0&id=0b16e3d3&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b16e3d3",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotTitle: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Title/Title.vue').default,HotAppStoreButton: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/AppStoreButton/AppStoreButton.vue').default})
